module.exports = __webpack_public_path__ + "img/arrow-up-big-small.37c53ce0.svg";